(() => {
if (customElements.get('fluff-product-recommendations')) return;
class FluffProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.response === 'true' || this.started || this.observer) return;
    const load = () => {
      if (this.started) return;
      this.started = true;
      this.observer?.disconnect();
      this.loadRecommendations(this.dataset.complementaryUrl, this.dataset.relatedUrl);
    };
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) load();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
    } else {
      load();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
  }

  async loadRecommendations(primaryUrl, fallbackUrl) {
    const primary = await this.fetchSection(primaryUrl);
    if (primary) {
      this.replaceChildren(primary);
      return;
    }
    const fallback = await this.fetchSection(fallbackUrl);
    if (fallback) this.replaceChildren(fallback);
  }

  async fetchSection(url) {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const source = documentFragment.querySelector('fluff-product-recommendations[data-response="true"][data-has-products="true"]');
      return source?.firstElementChild || null;
    } catch (error) {
      return null;
    }
  }
}

if (!customElements.get('fluff-product-recommendations')) customElements.define('fluff-product-recommendations', FluffProductRecommendations);

})();
